// Import all existing word sets
import { ZDANIA } from "@/consts.js";
import { ZDANIA3 } from "@/consts3.js";
import {
  ZDANIA4,
  ZDANIA5,
  ZDANIA6,
  ZDANIA7,
  ZDANIA8,
  ZDANIA10,
  ZDANIA11,
  ZDANIA12,
  ZDANIA14,
  ZDANIA15,
} from "@/consts4.js";
import { ZDANIA17, ZDANIA18 } from "@/consts5.js";
import { ZDANIA21, ZDANIA22 } from "@/consts6.js";
import { ZDANIA30, ZDANIA31, ZDANIA32, ZDANIA33, ZDANIA34 } from "@/consts7.js";
import { ZDANIA36, ZDANIA37, ZDANIA38 } from "@/consts8.js";
import { ZDANIA39 } from "@/consts9.js";
import { ZDANIA41, ZDANIA42, ZDANIA43, ZDANIA44 } from "@/consts10.js";
import { ZDANIA60, ZDANIA61, ZDANIA62 } from "@/consts11.js";
import { ZDANIA66, ZDANIA67 } from "@/consts12.js";
import { ZDANIA68, ZDANIA69 } from "@/consts13.js";
import { ZDANIA70, ZDANIA71, ZDANIA73, ZDANIA74, ZDANIA75, ZDANIA76, ZDANIA77 } from "@/consts14.js";
import { ZDANIA80, ZDANIA81 } from "@/consts15.js";
import { ZDANIA109, ZDANIA111 } from "@/consts16.js";
import { ZDANIA130 } from "@/consts17.js";
import { ZDANIA140, ZDANIA150, ZDANIA151, ZDANIA152, ZDANIA153, ZDANIA153_1, ZDANIA153_2,ZDANIA153_3, ZDANIA153_4, ZDANIA153_5, ZDANIA160, ZDANIA161 } from "@/consts18.js";

/**
 * Load all word sets from existing const files
 * This maintains backward compatibility with existing data
 */
export function loadLegacyWordSets() {
  return [
    ...ZDANIA161,
    ...ZDANIA160,
    ...ZDANIA153_5,
    ...ZDANIA153_4,
    ...ZDANIA153_3,
    ...ZDANIA153_2,
    ...ZDANIA153_1,
    ...ZDANIA153,
    ...ZDANIA152,
    ...ZDANIA151,
    ...ZDANIA150,
    ...ZDANIA140,
    ...ZDANIA130,
    ...ZDANIA111,
    ...ZDANIA109,
    ...ZDANIA81,
    ...ZDANIA80,
    ...ZDANIA77,
    ...ZDANIA76,
    ...ZDANIA75,
    ...ZDANIA74,
    ...ZDANIA73,
    ...ZDANIA71,
    ...ZDANIA70,
    ...ZDANIA69,
    ...ZDANIA68,
    ...ZDANIA67,
    ...ZDANIA66,
    ...ZDANIA62,
    ...ZDANIA61,
    ...ZDANIA60,
    ...ZDANIA44,
    ...ZDANIA43,
    ...ZDANIA42,
    ...ZDANIA41,
    ...ZDANIA39,
    ...ZDANIA38,
    ...ZDANIA37,
    ...ZDANIA36,
    ...ZDANIA34,
    ...ZDANIA33,
    ...ZDANIA32,
    ...ZDANIA31,
    ...ZDANIA30,
    ...ZDANIA22,
    ...ZDANIA21,
    ...ZDANIA18,
    ...ZDANIA17,
    ...ZDANIA15,
    ...ZDANIA14,
    ...ZDANIA12,
    ...ZDANIA11,
    ...ZDANIA10,
    ...ZDANIA7,
    ...ZDANIA6,
    ...ZDANIA5,
    ...ZDANIA4,
    ...ZDANIA3,
    ...ZDANIA,
    ...ZDANIA8,
  ];
}

/**
 * Load word sets from JSON file (new format)
 * Format: { sets: [{ id, name, lang, category, words: [{ pl, de }] }] }
 */
export async function loadJsonWordSets() {
  try {
    const response = await fetch('/data/wordSets.json');
    const data = await response.json();
    
    // Transform JSON format to app format
    return data.sets.map(set => ({
      name: set.name,
      lang: set.lang,
      category: set.category || 'general',
      zdania: set.words
    }));
  } catch (error) {
    console.warn('Could not load JSON word sets:', error);
    return [];
  }
}

/**
 * Main function to load all word sets
 * Combines legacy and new JSON formats
 */
export async function loadAllWordSets() {
  const legacySets = loadLegacyWordSets();
  const jsonSets = await loadJsonWordSets();
  
  return [...legacySets, ...jsonSets];
}

/**
 * Add new word set dynamically (stored in localStorage)
 * This allows users to add custom sets without modifying code
 */
export function addCustomWordSet(set) {
  const customSets = getCustomWordSets();
  customSets.push({
    id: `custom_${Date.now()}`,
    name: set.name,
    lang: set.lang,
    category: set.category || 'custom',
    words: set.words,
    createdAt: new Date().toISOString()
  });
  localStorage.setItem('langi_custom_sets', JSON.stringify(customSets));
}

/**
 * Get custom word sets from localStorage
 */
export function getCustomWordSets() {
  try {
    const stored = localStorage.getItem('langi_custom_sets');
    if (!stored) return [];
    
    const customSets = JSON.parse(stored);
    
    // Transform to app format
    return customSets.map(set => ({
      name: set.name,
      lang: set.lang,
      category: set.category || 'custom',
      zdania: set.words
    }));
  } catch (error) {
    console.error('Error loading custom sets:', error);
    return [];
  }
}

/**
 * Delete custom word set
 */
export function deleteCustomWordSet(setName) {
  const customSets = JSON.parse(localStorage.getItem('langi_custom_sets') || '[]');
  const filtered = customSets.filter(set => set.name !== setName);
  localStorage.setItem('langi_custom_sets', JSON.stringify(filtered));
}

/**
 * Export all custom sets as JSON (for backup)
 */
export function exportCustomSets() {
  const customSets = localStorage.getItem('langi_custom_sets');
  if (!customSets) return null;
  
  const blob = new Blob([customSets], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `langi_custom_sets_${Date.now()}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Import custom sets from JSON file
 */
export function importCustomSets(jsonString) {
  try {
    const imported = JSON.parse(jsonString);
    const existing = JSON.parse(localStorage.getItem('langi_custom_sets') || '[]');
    const merged = [...existing, ...imported];
    localStorage.setItem('langi_custom_sets', JSON.stringify(merged));
    return true;
  } catch (error) {
    console.error('Error importing sets:', error);
    return false;
  }
}
